import React from "react"

import bambooFibreImage from "../images/bamboo-fibre.jpg"
import bambooFibreMobileImage from "../images/bamboo-fibre-mobile.jpg"
import useMobileChecker from "../hooks/useMobileChecker"

const Hero = () => { 
  const isMobile = useMobileChecker();
  const imageToUse = isMobile
    ? bambooFibreMobileImage
    : bambooFibreImage

  return (
    <>
      <div className="o-grid__item--wide">
        <h1 className="c-heading c-heading--hero">Import Export Company based in Edmonton — your one-stop packaging solution</h1>
        <h2 className="c-heading c-heading--sub-hero">"Eco-friendly, biodegradable, inexpensive and safe packaging products for all merchants."</h2>
      </div>
      <div className="o-grid__item--full">
        <img className="c-image c-image--full-screen" src={imageToUse} alt="Bamboo Fibre" />
      </div>
    </>
  )
 }

export default Hero